import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Modal, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import useCustomList from './hooks/useCustomList';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { FormWrapper } from '../../../../components/formWrapper/form-wrapper';
import { noEmptyStringValidator } from '../../../../utility/forms';

export const ModalEditList = ({ customListId, show, handleClose }) => {
  const [form] = Form.useForm();
  const { translate: t } = useDictionaryTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { createList, customListData, updateList, isLoading } = useCustomList(customListId);

  const closeModal = (refreshData = false) => {
    form.resetFields();
    handleClose(refreshData);
  };

  const getFormData = () => {
    const values = form.getFieldsValue();

    return {
      title: values?.title,
      description: values?.description,
    };
  };

  const handleSubmit = async () => {
    const data = getFormData();
    setIsSubmitting(true);

    try {
      if (customListId) {
        await updateList(data);
      } else {
        await createList(data);
      }

      closeModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!show) return;

    if (!customListId) {
      form.resetFields();
      return;
    }

    form.setFieldsValue({
      title: customListData?.title ?? '',
      description: customListData?.description ?? '',
    });
  }, [show, customListId, customListData, form]);

  return (
    <Modal
      title={t(customListId ? 'updateList' : 'createList')}
      centered
      destroyOnClose
      width="30%"
      height="70%"
      onCancel={() => closeModal(false)}
      visible={show}
      footer={
        <div>
          <Button form="createList" key="submit" htmlType="submit" type="primary" disabled={isSubmitting || isLoading}>
            {t('save')}
          </Button>
        </div>
      }
    >
      <Spin spinning={isSubmitting || isLoading}>
        <FormWrapper>
          <Form name="createList" layout="vertical" form={form} onFinish={handleSubmit}>
            <Row>
              <Col xs={24} md={24}>
                <Form.Item
                  name="title"
                  label={t('name')}
                  rules={[{ validator: noEmptyStringValidator, required: true, message: t('nameIsRequired') }]}
                >
                  <Input placeholder={t('namePlaceholder')} />
                </Form.Item>
              </Col>

              <Col xs={24} md={24}>
                <Form.Item name="description" label={t('description')}>
                  <Input placeholder={t('description')} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </FormWrapper>
      </Spin>
    </Modal>
  );
};

ModalEditList.propTypes = {
  show: PropTypes.bool,
  customListId: PropTypes.string,
  handleClose: PropTypes.func,
};

export default ModalEditList;
